<template>
  <div>
    <confirmation-popup
      title="Send Job Request"
      id="sms-job-request-modal1"
      confirm-btn-text="Send"
      cancel-btn-text="Close"
    >
      <div class="row">
        <div class="form-group">
          <label class="col-md-2 control-label">Services</label>
          <div class="col-md-10">
            <select
              ref="sms_service_ids"
              id="sms_service_ids"
              name="sms_service_ids[]"
              class="form-control select2"
              multiple
              data-placeholder="All services"
            >
              <option
                v-for="service in bookingServices"
                v-if="service.multiple_day_ids"
                :value="service.service_id"
                :data-multiple_day_ids="service.multiple_day_ids.join(',')"
              >
                {{ service.service_name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row available-job_request">
        <available-fieldworkers-table
          :item-type="itemType"
          :contractorDistances="contractorDistances"
          :available_data="available_data"
          :fromJobRequestForm="true"
          :table-id="tableId"
        ></available-fieldworkers-table>
      </div>
      <div class="row" v-if="twilio_sms_active">
        <div class="col-md-6 col-md-offset-6">
          <label class="col-md-10 col-xs-10">Also send as SMS</label>
          <div class="material-switch material-switch-job">
            <input
              id="send_sms"
              type="checkbox"
              name="send_sms"
              @change="sendSmsChanged"
            />
            <label for="send_sms" class="label-default"></label>
          </div>
        </div>
      </div>
      <div class="row" v-if="twilio_sms_active">
        <div class="col-md-12 sms_message display-none">
          <div class="form-group">
            <label class="col-md-12 control-label">Sms message</label>
            <textarea name="sms_message" class="form-control" rows="6">{{
              smsMessage
            }}</textarea>
          </div>
        </div>
      </div>
      <div
        v-if="user_os !== 'web' && twilio_sms_active"
        class="hr-line-dashed"
      ></div>
      <div
        v-if="user_os !== 'web' && twilio_sms_active"
        class="form-group"
        style="margin-bottom: 10px; text-align: center"
      >
        <label class="col-xs-12" style="text-align: center">SMS option</label>
        <div class="col-xs-12" style="padding: 0">
          <div class="btn-group" role="group">
            <button
              type="button"
              id="job-request-sms-twillo"
              @click="companyClick"
              class="btn btn-primary job-request-sms"
            >
              Use company number
            </button>
            <button
              type="button"
              id="job-request-sms-phone"
              @click="phoneClick"
              class="btn btn-default job-request-sms"
            >
              Use my phone number
            </button>
            <input type="hidden" value="twillo" id="job-request-sms-option" />
          </div>
        </div>
        <br />
      </div>
    </confirmation-popup>
  </div>
</template>
<script>
import AvailableFieldworkersTable from "./AvailableFieldworkersTable.vue";

const table1Options = {
  paging: false,
  searching: false,
  columnDefs: [{ orderable: false, targets: [5] }],
  order: [1, "asc"],
};
export default {
  name: "JobRequestForm",
  components: { AvailableFieldworkersTable },
  props: {
    availableFieldworkers: {
      type: Array,
    },
    bookingServices: {
      type: Array,
    },
    available_data: {
      type: Object,
    },
  },
  data() {
    return {
      tableInitialized: false,
      table: null,
      contractorDistances: this.availableFieldworkers,
      selectedSmsServiceIds: [],
      tableId: "jobrequest_table",
      itemType: "booking",
    };
  },
  computed: {
    twilio_sms_active() {
      return this.available_data
        ? this.available_data.twilio_sms_active
        : false;
    },
    user_os() {
      return this.available_data ? this.available_data.user_os : "web";
    },
    smsMessage() {
      return this.available_data ? this.available_data.sms_message : "";
    },
  },
  methods: {
    changeAvailableContractors(availableContractorsData) {
      this.contractorDistances = availableContractorsData;
      this.$nextTick(function () {
        let rowCount = this.contractorDistances.length;
        $("#" + this.tableId)
          .parent()
          .find(".dataTables_info")
          .html("Showing " + rowCount + " records");
      });
    },
    companyClick(event) {
      $("#job-request-sms-phone").removeClass("btn-primary");
      $("#job-request-sms-phone").addClass("btn-default");
      $(this).removeClass("btn-default");
      $("#job-request-sms-option").val("twillo");
    },
    phoneClick(event) {
      $("#job-request-sms-twillo").removeClass("btn-primary");
      $("#job-request-sms-twillo").addClass("btn-default");
      $(this).removeClass("btn-default");
      $(this).addClass("btn-primary");
      $("#job-request-sms-option").val("phone");
    },
    sendSmsChanged(event) {
      if ($(event.target).is(":checked")) {
        $(".sms_message").slideDown();
      } else {
        $(".sms_message").slideUp();
      }
    },
  },
  mounted() {
    $(".select2").select2();
    if (this.twilio_sms_active && this.user_os != "web")
      $("#job-request-sms-twillo").trigger("click");
    $(".sms-job-request-mobiles").attr("checked", true);

    $(this.$refs.sms_service_ids).on("change", (event) => {
      this.$emit("changeSmsServices");
    });

    $("#sms-job-request-modal1")
      .find("button.btn-confirm")
      .attr("id", "sms-job-request-btn");
  },
  watch: {
    availableFieldworkers: {
      handler(contractors) {
        //When change avaialable fieldworkers from filters change it for job request form
        this.contractorDistances = contractors;
        $(this.$refs.sms_service_ids).val([]);
        // this.selectedSmsServiceIds = []
        this.$nextTick(function () {
          let rowCount = this.contractorDistances.length;
          $("#" + this.tableId)
            .parent()
            .find(".dataTables_info")
            .html("Showing " + rowCount + " records");
        });
      },
    },
  },
};
</script>
<style scoped>
.table-responsive {
  padding: 0px;
  margin: 0px;
}
.table-responsive .table {
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  vertical-align: middle;
}
tr.heading-row {
  font-weight: bold;
}
.contractor-img {
  //height: 50px;
}
</style>
